export default {
    // 教師
    kazuyuki_matsumoto: {
      name_jp: "松本和幸",
      name_en: "Kazuyuki Matsumoto",
      jobTitle: "准教授",
      major: ["感性情報処理", "自然言語処理"],
      introduce:
        "2008年、徳島大学大学院工学研究科博士後期課程修了。博士（工学）。2009年10月より徳島大学工学部助教を経て、2020年4月より現在まで、徳島大学大学院社会産業理工学研究部准教授。介護福祉ロボットに応用するための言語情報からの感情計算、自然言語処理、昨今ではSNS上の炎上対策のための俗語や評判分析の研究を行っている。言語処理学会、日本感性工学会、人工知能学会、Association for the Advancement of Affective Computing(AAAC)各会員。",
      isTeacher: true,
      images: [
        require('@/assets/jikoshoukai/matumoto.png'),
      ],
    },
    minoru_yoshida:{
      name_jp: "吉田稔",
      name_en: "Minoru Yoshida",
      jobTitle: "講師",
      major: ["情報通信", "知能情報学"],
      introduce:
          "2003年、東京大学大学院理学系研究科博士課程情報科学専攻修了。博士（理学）。東京大学情報基盤センター助教を経て，2013 年より徳島大学大学院ソシオテクノサイエンス研究部講師。現在、徳島大学大学院社会産業理工学研究部講師。教師無し学習によるWWWからの情報抽出，テキストマイニング，テキスト中の数値情報解析に関する研究に従事。情報処理学会，言語処理学会，人工知能学会，日本データベース学会各会員。",
      isTeacher: true,
    },
    kang_xin:{
      name_jp: "康鑫",
      name_en: "Kang Xin",
      jobTitle: "講師",
      major: [""],
      introduce:
          "2013年、徳島大学大学院工学研究科博士後期課程修了。博士（工学）。2009年北京郵電大学で修士課程を修了し、2006年東北大学で学士課程を修了。現在、徳島大学の助教としてマルチモーダル感情コンピューティング、信頼できる人工知能、感情コンピューティング、メンタルヘルスケア、ファイナンシャルインテリジェンスを含む学際的研究に従事。IEEE、ACM、ACLの各会員。",
      isTeacher: true,
    },
    // 連携
    ryota_nishimura:{
      name_jp: "西村良太",
      name_en: "Ryota Nishimura",
      jobTitle: "講師",
      major: ["情報学"],
      introduce:
          "2007年 豊橋技術科学大学大学院修士課程情報工学専攻修了．2010年 同大学院博士後期課程電子・情報工学専攻修了．2011年 名古屋大学大学院技術補佐員．2012年 名古屋工業大学特任助教．2014年 慶應義塾大学特任助教，2017年 徳島大学特任研究員．2018年 同大学講師，現在に至る．主として音声対話システムに関する研究に従事し、特に自然なリズムの対話を音声対話システムにて実現することを目指す．IEEE (Senior Member)，ISCA，APSIPA，電子情報通信学会，情報処理学会，日本音響学会，人工知能学会，日本音声学会各会員．博士（工学）．",
      isTeacher: true,
    },
    // D3
    wang: {
      name_jp: "王麟皇",
      name_en: "Linhuang Wang",
      grade: "博士3年",
      theme: "",
      links: [
        {
          url: "https://wlh0517.github.io/",
          title: "Linhuang Wang - Homepage"
        },
      ],
      group: "",
      introduce: "",
      isTeacher: false
    },
  };